import IconArrowRight from '@root/joinroot.com/src/assets/components/icons/arrow-right';
import PropTypes from '@root/vendor/prop-types';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function ButtonInnerContainer({ children }) {
  return (
    <div css={styles.container}>
      <span>{children}</span>
      <IconArrowRight />
    </div>
  );
}

ButtonInnerContainer.propTypes = {
  children: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    'svg': {
      flexShrink: 0,
      marginLeft: 20,
    },
  },
});
